import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-is-client',
  templateUrl: './is-client.component.html',
  styleUrls: ['./is-client.component.scss', '../../sign-up.component.scss'],
})
export class IsClientComponent implements OnInit {

  @Input() isClientControl: UntypedFormControl = new UntypedFormControl(null, Validators.required)

  @Input() clientCodeControl: UntypedFormControl = new UntypedFormControl(null, Validators.required)

  clientCodeForm = new UntypedFormGroup({});

  ngOnInit(): void {
    this.clientCodeForm.addControl('clientCode', this.clientCodeControl);
  }



}
